<template>
  <div id="app-content">
    <topbar></topbar>
    <navbar></navbar>
    <router-view class="content"/>
  </div>
</template>

<script>
import { mapState } from "vuex";
import topbar from "@/components/topbar";
import navbar from "@/components/navbar";

export default {
  name: "index-content",
  components: {
    topbar,
    navbar
  },
  computed: {
    ...mapState({
      account: "account"
    })
  },
  created() {
    this.loadLocalData();
    // this.loadAnalysis('dwDataAyl');
    // this.loadAnalysis('upDataAyl');
    // this.loadAnalysis('lenAyl');
    // this.loadAnalysis('ckAyl');
  },
  mounted() {},

  methods: {
    loadLocalData() {
      let accountInfo = JSON.parse(localStorage.getItem("account"));
      if (accountInfo) {
        this.$store.dispatch("updataAccount", accountInfo);
      }
    },
    loadAnalysis(type){
      let url = 'analysis',
          params={
            auth_token:'default',
            ayl_type:type
          };
      this.$http.get(url,{params}).then(data=>{
        console.log(data)
      })
    }


  }
};
</script>

<style type="scss" scoped>
.content {
  padding-top: 71px;
  padding-left: 255px;
  padding-right: 15px;
}
@media (max-width: 991px) {
  .content {
    padding-top: 71px;
    padding-left: 60px;
    padding-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/content.vue